module.exports = __webpack_public_path__ + "media/tycho2t3_80_grey_px.cb1c6e50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/sky_box/tycho2t3_80_grey_px.jpg
// module id = 1095
// module chunks = 0